<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form [formGroup]="businessUnitForm" (ngSubmit)="saveBusinessUnit()" novalidate autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="off">
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-building mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <label for="businessUnitName" class="block text-900 font-medium mb-2">Business Unit Name</label>
          <input id="businessUnitName" type="text" pInputText formControlName="businessUnitName" class="w-full" />
          <small *ngIf="businessUnitForm.get('businessUnitName')?.invalid && businessUnitForm.get('businessUnitName')?.touched" class="p-error">
            Business Unit Name is required.
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <label for="businessUnitCode" class="block text-900 font-medium mb-2">Business Unit Code</label>
          <input id="businessUnitCode" type="text" pInputText formControlName="businessUnitCode" class="w-full" />
        </div>

        <div class="field col-12 md:col-6">
          <label for="arAccount" class="block text-900 font-medium mb-2">AR Account</label>
          <input id="arAccount" type="text" pInputText formControlName="arAccount" class="w-full" />
        </div>

        <div class="field col-12 md:col-6">
          <label for="apAccount" class="block text-900 font-medium mb-2">AP Account</label>
          <input id="apAccount" type="text" pInputText formControlName="apAccount" class="w-full" />
        </div>

        <div class="field col-12 md:col-6">
          <label for="reference" class="block text-900 font-medium mb-2">Reference</label>
          <input id="reference" type="text" pInputText formControlName="reference" class="w-full" />
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <p-button label="Cancel" styleClass="p-button-secondary" type="button" (onClick)="cancel()"></p-button>
      <p-button [label]="isEditMode ? 'Update Business Unit' : 'Save Business Unit'" type="submit" [disabled]="businessUnitForm.invalid"></p-button>
    </div>
  </form>
</div>
